import { cn } from "@/lib/utils";

interface DocTableProps {
  headers: string[];
  rows: React.ReactNode[][];
  monoColumns?: number[];
}

export function DocTable({ headers, rows, monoColumns = [] }: DocTableProps) {
  return (
    <div className="my-5 overflow-x-auto rounded-xl border border-border shadow-sm">
      <table className="w-full border-collapse text-sm">
        <thead>
          <tr className="border-b border-border bg-primary/10">
            {headers.map((header, index) => (
              <th
                key={index}
                className="px-2 py-2 text-left text-xs font-semibold uppercase tracking-wide text-foreground sm:px-4 sm:py-3"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-card">
          {rows.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className={cn(
                "border-b border-border last:border-b-0",
                rowIndex % 2 === 1 && "bg-muted/30"
              )}
            >
              {row.map((cell, cellIndex) => (
                <td
                  key={cellIndex}
                  className={cn(
                    "px-2 py-2 text-foreground sm:px-4 sm:py-3",
                    monoColumns.includes(cellIndex) && "font-mono text-xs"
                  )}
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
